function scrollIinit() {
  let $header;
  let $body;
  let isAtTop = true;
  const scrollMargin = 50;
  let lastScrollTop = 0;
  let lastDirection = null; // 'up' | 'down'
  let upStartScrollTop = null; // anchor point when starting to scroll up

  function trackScroll() {
    const scrollTop = $(window).scrollTop();
    const isScrollingUp = lastScrollTop > scrollTop;
    let newDirection = lastDirection;
    if (isScrollingUp) {
      newDirection = 'up';
    } else if (lastScrollTop < scrollTop) {
      newDirection = 'down';
    }

    // Handle direction changes and threshold logic for 'is-scrolling-up'
    if (newDirection === 'up') {
      if (lastDirection !== 'up') {
        // Direction just changed to up; set anchor from which to measure upward distance
        upStartScrollTop = lastScrollTop;
      }
      if (upStartScrollTop !== null && (upStartScrollTop - scrollTop) >= 100) {
        $header.addClass('is-scrolling-up');
        $header.removeClass('is-scrolling-down');
        $body.addClass('is-scrolling-up');
      }
    } else if (newDirection === 'down') {
      // Any downward scroll removes the class and resets the anchor
      $header.removeClass('is-scrolling-up');
      $header.addClass('is-scrolling-down');
      $body.removeClass('is-scrolling-up');
      upStartScrollTop = null;
    }

    if (
      (scrollTop <= scrollMargin && !isAtTop)
      || (scrollTop > scrollMargin && isAtTop)
    ) {
      isAtTop = !isAtTop;

      if (isAtTop) {
        $header.addClass('is-at-top');
      } else {
        $header.removeClass('is-at-top');
      }
    }

    // Roep de functie opnieuw aan tijdens de volgende animatieframe
    window.requestAnimationFrame(trackScroll);
    lastDirection = newDirection;
    lastScrollTop = scrollTop;
  }

  jQuery(($) => {
    $header = $('.js-header');
    $body = $('body');
    lastScrollTop = $(window).scrollTop();

    // Start de scroll-tracking bij het laden van de pagina
    trackScroll();
  });
}

scrollIinit();
